import TweenMax from "gsap";

export default class Destroyer {
    constructor(gameCache) {
        this._gameCache = gameCache;
    }

    /**
     * @param{OTicker} timer
     */
    timer(timer) {
        if (timer) {
            timer.destroy();
            timer = null;
        }
    }

    /**
     * kill tween of target
     * @param{Object} target
     * @param{Object} vars
     */
    tween(target, vars = null) {
        TweenMax.killTweensOf(target, vars);
        target = null;
        vars = null;
    }

    actorAtlas(a) {
        if (a.parent)
            a.parent.removeChild(a);
        this._gameCache.setActorAtlas(a);
    }

    revoltParticleEmitter(particle) {
        particle.destroy();
        particle = null;
    }

    revoltParticleSequence(particle) {
        particle.destroy();
        particle = null;
    }

    /**
     * Remove DisplayObject from Layer Group and return render in parent
     * @param {*} displayObject
     */
    removeFromLayer(displayObject) {
        displayObject.parentGroup = null;
        displayObject._activeParentLayer = null;
        displayObject._activeStage = null;
        delete displayObject.parentGroup;
        delete displayObject._activeParentLayer;
        delete displayObject._activeStage;
    }
}
